/**
 * @generated SignedSource<<e3bbb27bd6dc09ebb517466e1084d5d8>>
 * @relayHash 33443d3c71a93e19039c1ddf91e01c8b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 662fd8d1f9c5eb8fd7858db090e25a7b50b561452bb8cf112ce7e305b62eb98f

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { pageLayout_projectsDirectoryLayout_RootQuery } from './pageLayout_projectsDirectoryLayout_RootQuery.graphql';

const node: PreloadableConcreteRequest<pageLayout_projectsDirectoryLayout_RootQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "662fd8d1f9c5eb8fd7858db090e25a7b50b561452bb8cf112ce7e305b62eb98f",
    "metadata": {},
    "name": "pageLayout_projectsDirectoryLayout_RootQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
